import { render, staticRenderFns } from "./ed-section-material.vue?vue&type=template&id=4d2213a6&scoped=true&"
import script from "./ed-section-material.ts?vue&type=script&lang=ts&"
export * from "./ed-section-material.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-material.scss?vue&type=style&index=0&id=4d2213a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2213a6",
  null
  
)

export default component.exports